import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpHeaders,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionDataService } from './../services/session-data.service';
import { UtilitiesService } from './utilities.service';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  constructor() {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    request = request.clone({
      headers: new HttpHeaders({
        Channel: 'Portal',
        transactionId: Date.now().toString(),
      }),
      withCredentials: true,
    });

    return next.handle(request);
  }
}
